module.exports = __webpack_public_path__ + "img/mac-error2.64c776a6.svg";